/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const onUpdatedRoom = /* GraphQL */ `
  subscription OnUpdatedRoom($owner: String!, $editors: [String]!) {
    onUpdatedRoom(owner: $owner, editors: $editors) {
      id
      name
      gameId
      gameTitle
      gameDescription
      fieldTags
      isCopiedGame
      game {
        id
        title
        description
        cards {
          id
          tag
          faceUpString
          faceDownString
        }
        characters {
          id
          name
        }
        fieldTags
        createdAt
        updatedAt
        owner
      }
      characters {
        id
        name
        editor
      }
      cards {
        id
        tag
        isDeal
        faceUpString
        faceDownString
        editor
        isAllOpen
        isGroupOpen
      }
      groups {
        id
        members
      }
      guests {
        items {
          id
          roomId
          userName
          name
          createdAt
          updatedAt
        }
        nextToken
      }
      requests {
        items {
          id
          roomId
          userName
          name
          isAccept
          createdAt
          updatedAt
        }
        nextToken
      }
      editors
      createdAt
      owner
      updatedAt
    }
  }
`;
export const onCreateGame = /* GraphQL */ `
  subscription OnCreateGame($owner: String!) {
    onCreateGame(owner: $owner) {
      id
      title
      description
      cards {
        id
        tag
        faceUpString
        faceDownString
      }
      characters {
        id
        name
      }
      fieldTags
      createdAt
      updatedAt
      owner
    }
  }
`;
export const onUpdateGame = /* GraphQL */ `
  subscription OnUpdateGame($owner: String!) {
    onUpdateGame(owner: $owner) {
      id
      title
      description
      cards {
        id
        tag
        faceUpString
        faceDownString
      }
      characters {
        id
        name
      }
      fieldTags
      createdAt
      updatedAt
      owner
    }
  }
`;
export const onDeleteGame = /* GraphQL */ `
  subscription OnDeleteGame($owner: String!) {
    onDeleteGame(owner: $owner) {
      id
      title
      description
      cards {
        id
        tag
        faceUpString
        faceDownString
      }
      characters {
        id
        name
      }
      fieldTags
      createdAt
      updatedAt
      owner
    }
  }
`;
export const onCreateRoom = /* GraphQL */ `
  subscription OnCreateRoom($owner: String!) {
    onCreateRoom(owner: $owner) {
      id
      name
      gameId
      gameTitle
      gameDescription
      fieldTags
      isCopiedGame
      game {
        id
        title
        description
        cards {
          id
          tag
          faceUpString
          faceDownString
        }
        characters {
          id
          name
        }
        fieldTags
        createdAt
        updatedAt
        owner
      }
      characters {
        id
        name
        editor
      }
      cards {
        id
        tag
        isDeal
        faceUpString
        faceDownString
        editor
        isAllOpen
        isGroupOpen
      }
      groups {
        id
        members
      }
      guests {
        items {
          id
          roomId
          userName
          name
          createdAt
          updatedAt
        }
        nextToken
      }
      requests {
        items {
          id
          roomId
          userName
          name
          isAccept
          createdAt
          updatedAt
        }
        nextToken
      }
      editors
      createdAt
      owner
      updatedAt
    }
  }
`;
export const onUpdateRoom = /* GraphQL */ `
  subscription OnUpdateRoom($owner: String!, $editors: String!) {
    onUpdateRoom(owner: $owner, editors: $editors) {
      id
      name
      gameId
      gameTitle
      gameDescription
      fieldTags
      isCopiedGame
      game {
        id
        title
        description
        cards {
          id
          tag
          faceUpString
          faceDownString
        }
        characters {
          id
          name
        }
        fieldTags
        createdAt
        updatedAt
        owner
      }
      characters {
        id
        name
        editor
      }
      cards {
        id
        tag
        isDeal
        faceUpString
        faceDownString
        editor
        isAllOpen
        isGroupOpen
      }
      groups {
        id
        members
      }
      guests {
        items {
          id
          roomId
          userName
          name
          createdAt
          updatedAt
        }
        nextToken
      }
      requests {
        items {
          id
          roomId
          userName
          name
          isAccept
          createdAt
          updatedAt
        }
        nextToken
      }
      editors
      createdAt
      owner
      updatedAt
    }
  }
`;
export const onDeleteRoom = /* GraphQL */ `
  subscription OnDeleteRoom($owner: String!) {
    onDeleteRoom(owner: $owner) {
      id
      name
      gameId
      gameTitle
      gameDescription
      fieldTags
      isCopiedGame
      game {
        id
        title
        description
        cards {
          id
          tag
          faceUpString
          faceDownString
        }
        characters {
          id
          name
        }
        fieldTags
        createdAt
        updatedAt
        owner
      }
      characters {
        id
        name
        editor
      }
      cards {
        id
        tag
        isDeal
        faceUpString
        faceDownString
        editor
        isAllOpen
        isGroupOpen
      }
      groups {
        id
        members
      }
      guests {
        items {
          id
          roomId
          userName
          name
          createdAt
          updatedAt
        }
        nextToken
      }
      requests {
        items {
          id
          roomId
          userName
          name
          isAccept
          createdAt
          updatedAt
        }
        nextToken
      }
      editors
      createdAt
      owner
      updatedAt
    }
  }
`;
export const onCreateGuest = /* GraphQL */ `
  subscription OnCreateGuest {
    onCreateGuest {
      id
      roomId
      userName
      name
      createdAt
      updatedAt
    }
  }
`;
export const onUpdateGuest = /* GraphQL */ `
  subscription OnUpdateGuest {
    onUpdateGuest {
      id
      roomId
      userName
      name
      createdAt
      updatedAt
    }
  }
`;
export const onDeleteGuest = /* GraphQL */ `
  subscription OnDeleteGuest {
    onDeleteGuest {
      id
      roomId
      userName
      name
      createdAt
      updatedAt
    }
  }
`;
export const onCreateRequest = /* GraphQL */ `
  subscription OnCreateRequest {
    onCreateRequest {
      id
      roomId
      userName
      name
      isAccept
      createdAt
      updatedAt
    }
  }
`;
export const onUpdateRequest = /* GraphQL */ `
  subscription OnUpdateRequest {
    onUpdateRequest {
      id
      roomId
      userName
      name
      isAccept
      createdAt
      updatedAt
    }
  }
`;
export const onDeleteRequest = /* GraphQL */ `
  subscription OnDeleteRequest {
    onDeleteRequest {
      id
      roomId
      userName
      name
      isAccept
      createdAt
      updatedAt
    }
  }
`;
